import { render, staticRenderFns } from "./ProductDetail.vue?vue&type=template&id=7bc9dc3f&scoped=true"
import script from "./ProductDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductDetail.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ProductDetail.vue?vue&type=style&index=0&id=7bc9dc3f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc9dc3f",
  null
  
)

export default component.exports